export type FundingTimescale = 'DAY' | 'WEEK' | 'MONTH';

export const FUNDING_CHART_TIMESCALES = [
  { value: 'DAY', label: '1d' },
  { value: 'WEEK', label: '1w' },
  { value: 'MONTH', label: '1m' },
] as const satisfies Array<{ value: FundingTimescale; label: string }>;

export const DEFAULT_FUNDING_CHART_TIMESCALE = 'DAY' satisfies FundingTimescale;
